import { axiosRequestHandler } from '../../../helpers/apiHelper';

export const FetchLocationAPI = async (data) => {
  try {
    return await axiosRequestHandler(
      `locations?${data?.id ? `projects[]=${data.id}&` : ''}includes[]=zones.areas`,
      'get'
    );
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const AddLocationAPI = async (data) => {
  try {
    return await axiosRequestHandler(`locations`, 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const UpdateLocationAPI = async (data) => {
  try {
    return await axiosRequestHandler(`locations/${data.id}`, 'put', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DeleteLocationAPI = async (data) => {
  try {
    return await axiosRequestHandler(`locations/${data.id}`, 'delete', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DuplicateLocationAPI = async (data) => {
  try {
    return await axiosRequestHandler(`locations/${data.id}/duplicate`, 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const AddZoneAPI = async (data) => {
  try {
    return await axiosRequestHandler(`locations/${data.locationId}/zones`, 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const UpdateZoneAPI = async (data) => {
  try {
    return await axiosRequestHandler(`zones/${data.id}`, 'put', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DeleteZoneAPI = async (data) => {
  try {
    return await axiosRequestHandler(`zones/${data.id}`, 'delete');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DuplicateZoneAPI = async (id) => {
  try {
    return await axiosRequestHandler(`zones/${id}/duplicate`, 'post');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const AddAreaAPI = async (data) => {
  try {
    return await axiosRequestHandler(`zones/${data.zoneId}/areas`, 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const UpdateAreaAPI = async (data) => {
  try {
    return await axiosRequestHandler(`areas/${data.id}`, 'put', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const UpdateAreaPercentValueAPI = async (data) => {
  try {
    return await axiosRequestHandler(`areas`, 'put', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DeleteAreaAPI = async (data) => {
  try {
    return await axiosRequestHandler(`areas/${data.id}`, 'delete');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};
